"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterRatesByAge = void 0;
function filterRatesByAge(rates, options, ageReplacementRules = []) {
    const age = options.age;
    const stateReplacements = ageReplacementRules.filter(rule => rule.state === options.state);
    if (stateReplacements.length === 0) {
        return rates.filter(rate => isAgeInRange(age, rate));
    }
    return filterRatesByAgeUsingReplacements(rates, age, stateReplacements);
}
exports.filterRatesByAge = filterRatesByAge;
function filterRatesByAgeUsingReplacements(rates, age, ageReplacementRules) {
    return rates.filter(rate => doesRateMatchAgeUsingReplacements(rate, age, ageReplacementRules));
}
function doesRateMatchAgeUsingReplacements(rate, age, ageReplacementRules) {
    const replacementRule = ageReplacementRules.find(rule => rule.matchOn.minAge === rate.minAge && rule.matchOn.maxAge === rate.maxAge);
    if (!replacementRule) {
        return isAgeInRange(age, rate);
    }
    return isAgeInRange(age, replacementRule.replaceWith);
}
function isAgeInRange(age, range) {
    return age >= range.minAge && age <= range.maxAge;
}
//# sourceMappingURL=age-filterer.js.map